import styled from 'styled-components'

const Button = styled<any>('button')`
  color: rgb(54, 63, 65);
  cursor: pointer;
  font-family: AvenirNext-DemiBold;
  font-size: 14px;
  font-weight: 600;
  height: 44px;
  text-align: center;
  width: 114px;
  background: transparent;
  border-radius: 22px;
  border: 1px solid rgb(204, 207, 207);
  outline: none;

  &:active {
    background-color: #f9f9fc;
  }

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.4;
  }
`

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 200px;
`

export { Button, ButtonRow }
